var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 24,
    viewBox: "0 0 57 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_203_3175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_1_89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.7646 0H12.0612C5.39997 0 0 5.37258 0 12C0 18.6274 5.39997 24 12.0612 24H44.7646C51.4258 24 56.8258 18.6274 56.8258 12C56.8258 5.37258 51.4258 0 44.7646 0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_203_3175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_d_203_3175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.7136 0H12.0612C5.39997 0 0 5.37258 0 12C0 18.6274 5.39997 24 12.0612 24H44.7136C51.3748 24 56.7748 18.6274 56.7748 12C56.7748 5.37258 51.3748 0 44.7136 0Z",
    fill: "url(#paint0_linear_203_3175)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.82678 11.9999C1.82678 6.30897 6.46372 1.69556 12.1837 1.69556H32.6884V22.3043H12.1837C6.46372 22.3043 1.82678 17.6908 1.82678 11.9999Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.3205 14.0432C42.7484 14.569 41.9719 14.8695 41.1545 14.8695C40.3372 14.8695 39.5607 14.569 38.9886 14.0055C37.7626 12.8786 37.7626 11.0755 38.9886 9.94846L43.8109 5.47827L48.6332 9.94846C49.8592 11.0755 49.8592 12.8786 48.6332 14.0055L48.5923 14.0432C47.4073 15.1325 45.4458 15.1326 44.2606 14.0057C44.3751 15.7614 45.6669 17.1914 47.344 17.4938V18H40.2772V17.4938C41.9673 17.1891 43.2661 15.7394 43.3632 13.965L43.3205 14.0432Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.4915 16.0506V9.80116H22.165V7.94946H28.9117V9.80116H26.5852V16.0506H24.4915Z",
    fill: "url(#paint1_linear_203_3175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4739 16.0506V14.4883L19.1962 9.7433H15.5902V7.94946H21.8715V9.51183L18.1493 14.2568H21.9297V16.0506H15.4739Z",
    fill: "url(#paint2_linear_203_3175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.62769 16.0506V7.94946H10.3031L12.9785 12.9838V7.94946H15.0722V16.0506H12.3969L9.72147 11.0163V16.0506H7.62769Z",
    fill: "url(#paint3_linear_203_3175)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_203_3175",
    x: -13,
    y: -11,
    width: 82.7748,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.952941 0 0 0 0 0.635294 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_3175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_3175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_3175",
    x1: 1.30818,
    y1: -2.82373e-7,
    x2: 56.7232,
    y2: 24.1185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FE9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_3175",
    x1: 8.11806,
    y1: 7.94947,
    x2: 28.1476,
    y2: 17.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FE9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_3175",
    x1: 8.11804,
    y1: 7.94947,
    x2: 28.1476,
    y2: 17.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FE9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_203_3175",
    x1: 8.1181,
    y1: 7.94947,
    x2: 28.1477,
    y2: 17.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FE9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BFFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/mainLogo.5d9effee3c8b3943558d07d88e287513.svg";
export { ForwardRef as ReactComponent };